"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecisionDescriptionTypeCodeMapping = exports.DecisionTypeDescription = exports.DecisionTypeCode = void 0;
var DecisionTypeCode;
(function (DecisionTypeCode) {
    DecisionTypeCode[DecisionTypeCode["Pass"] = 1] = "Pass";
    DecisionTypeCode[DecisionTypeCode["Fail"] = 2] = "Fail";
    DecisionTypeCode[DecisionTypeCode["Warning"] = 3] = "Warning";
    DecisionTypeCode[DecisionTypeCode["Review"] = 4] = "Review";
})(DecisionTypeCode = exports.DecisionTypeCode || (exports.DecisionTypeCode = {}));
var DecisionTypeDescription;
(function (DecisionTypeDescription) {
    DecisionTypeDescription["Pass"] = "PASS";
    DecisionTypeDescription["Fail"] = "FAIL";
    DecisionTypeDescription["Warning"] = "WARNING";
    DecisionTypeDescription["Review"] = "REVIEW";
})(DecisionTypeDescription = exports.DecisionTypeDescription || (exports.DecisionTypeDescription = {}));
exports.DecisionDescriptionTypeCodeMapping = (_a = {},
    _a[DecisionTypeDescription.Pass] = DecisionTypeCode.Pass,
    _a[DecisionTypeDescription.Fail] = DecisionTypeCode.Fail,
    _a[DecisionTypeDescription.Warning] = DecisionTypeCode.Warning,
    _a[DecisionTypeDescription.Review] = DecisionTypeCode.Review,
    _a);
